import type { SerializedCombinedMeter } from '@enmon/commons/lib/enmon';

export function readBootstrapMeterTechnicalFields(meter: SerializedCombinedMeter) {
  return {
    accessibility: meter.accessibility,
    detail: meter.detail,
    lorawanRssi: meter.lorawan_rssi,
    mountTechnology: meter.meter_mount_technology,
    mountType: meter.meter_mount_type,
    nbiotRssi: meter.nbiot_rssi,
    remoteReadingOwner: meter.remote_reading_owner,
    remoteReadingSerial: meter.remote_reading_serial,
    requiresManualAks: meter.requires_manual_aks,
  };
}
